/**
 * Lifecycle de la commande client.
 *
 * Depuis le découplage (Phase 3 — avril 2026), l'`etat` représente uniquement
 * le cycle de vie métier. Les axes "expédition" et "facturation" sont
 * désormais portés par `EtatExpedition` et `EtatFacturation`.
 *
 * Phase 4 (avril 2026) : suppression de `PRETE` — auto-passage en `TERMINE`
 * dès `etatExpedition = TOTAL`. Bouton bidirectionnel pour passer en TERMINE
 * manuellement ou rouvrir une CC TERMINEE.
 *
 * Voir `docs/audits/commande-client-decouplage-PLAN.md` et
 * `docs/audits/DECISION-suppression-prete.md`.
 */
export enum CommandeClientEtat {
  EN_REDACTION = "EN_REDACTION",
  EN_ATTENTE_CONFIRMATION = "EN_ATTENTE_CONFIRMATION",
  EN_ATTENTE_CONFIRMATION_MODIFIED = "EN_ATTENTE_CONFIRMATION_MODIFIED",
  EN_COURS_DE_TRAITEMENT = "EN_COURS_DE_TRAITEMENT",
  EN_COURS_DE_PREPARATION = "EN_COURS_DE_PREPARATION",
  /** @deprecated Phase 4 : remplacé par auto-passage en `TERMINE` quand
   *  `etatExpedition = TOTAL`. Conservé pour rétro-compat données legacy. */
  PRETE = "PRETE",
  /** @deprecated Phase 3 : utiliser `EtatExpedition.TOTAL`. Plus assigné. */
  EXPEDIE = "EXPEDIE",
  /** @deprecated Phase 3 : utiliser `EtatExpedition.PARTIELLEMENT`. */
  EXPEDIE_PARTIELLEMENT = "EXPEDIE_PARTIELLEMENT",
  /** @deprecated Phase 3 : utiliser `EtatFacturation.PARTIELLEMENT`. */
  FACTURE_PARTIELLEMENT = "FACTURE_PARTIELLEMENT",
  /** @deprecated Phase 3 : utiliser `EtatFacturation.TOTAL`. */
  FACTURE = "FACTURE",
  /** @deprecated Annulation via flag `dateAnnulation`. */
  ANNULEE = "ANNULEE",
  TERMINE = "TERMINE",
}

export enum CommandeClientEtatLibelle {
  EN_REDACTION = "En rédaction",
  EN_ATTENTE_CONFIRMATION = "En attente de confirmation",
  EN_ATTENTE_CONFIRMATION_MODIFIED = "En attente de confirmation (modifiée)",
  EN_COURS_DE_TRAITEMENT = "En cours de traitement",
  EN_COURS_DE_PREPARATION = "En cours de préparation",
  PRETE = "Prête",
  EXPEDIE = "Expédié",
  EXPEDIE_PARTIELLEMENT = "Expédié partiellement",
  FACTURE_PARTIELLEMENT = "Facturé partiellement",
  FACTURE = "Facturé",
  ANNULEE = "Annulée",
  TERMINE = "Terminé",
}
